import React, {useEffect} from 'react'
import styled from 'styled-components'
import Footer from '../Footer'
import Funding from '../Funding'
import Header from '../Header'
import LoanProcess from '../LoanProcess'


function LoanComponent() {

    useEffect(()=>{
        window.scrollTo(0,0)
      },[])
    return (
        <>
            <Header/>
            <Banner>
                <div className="banner__container">
                    <div className="banner__content">
                        <h2>Loans</h2>
                        <p>Our loans are affordable, accessible and reliable… </p>
                    </div>
                    <div className="banner__background"></div>
                </div>
            </Banner>
            <AboutLoan>
                <Container>
                    <div className="loan__image">
                        <img src="/images/team/team.jpg" alt=""/>
                    </div>
                    <Content className="loan__content">
                        <h2>What is a Winnthako Loan</h2>
                        <p>A platform designed to loan out money to people/groups to enable them solve their urgent needs/problems. It is a system where you are given Money, which will be paid back later with some added interest depending on the time period.</p>
                        <br/>
                        <p>In the case of default in payment, the collateral/items given, will seize to be the owner's property.</p>
                        <ul className="category">
                            <li>Maximum amount #100,000.</li>
                            <li>Maximum pay back period 8 weeks (2 months)</li>
                            {/* <li>FREE Mentoring For The First Year Of The Loan</li>
                            <li>No Minimum Trading Requirement.</li> */}
                        </ul>
                        {/* <h3>Resources to help you with your Loan</h3>
                        <ul className="values">
                            <li><span><i class="fa fa-check" aria-hidden="true"></i></span> Excellence</li>
                            <li><span><i class="fa fa-check" aria-hidden="true"></i></span>Reliability</li>
                            <li><span><i class="fa fa-check" aria-hidden="true"></i></span>Innovation</li>
                        </ul> */}
                    </Content>
                </Container>
            </AboutLoan>
            <LoanProcess/>
            <Funding/> 
            <Footer/> 
        </>
    )
}


const Banner = styled.div`
    .banner__container{
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        z-index: 1;
        position: relative;
        background: black;
        overflow: hidden;
        p{
            color: rgb(255, 255, 255);
        }
    }

    .banner__background{
        background: linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)), url("/images/team/group.jpg");
        background-size: cover;
        background-position-x: center;
        background-attachment: fixed;
        position: absolute;
        opacity: 0.3;
        top: 0;
        height: 100%;
        width: 100vw;
        z-index: -1;
    }
    
    .banner__content{
        color: rgb(255, 255, 255);
        max-width: 80%;
        padding: 10% 20px;
        p{
            color: rgb(255, 255, 255);
        }
    }
    
`

const AboutLoan = styled.div``

const Container = styled.div`
    padding: 50px 20px;
    display: flex;
    flex-direction: column;
    img{
        width: 100%;
    }

    @media(min-width: 768px){
        flex-direction: row;
        justify-content: space-around;

        div.loan__image{
            width: 40%;
            margin: auto 0;
        }

        h2{
            font-weight: 400;
        }
        h3{
            font-size: 18px;
            
        }
    
    }
`
const Content = styled.div`

    @media(min-width: 768px){
        width: 40%;
    }
    ul.values{
        list-style-type: none;
        padding-left: 0;

        li{
            color: rgb(96, 96, 96);
            margin-bottom: 10px;
        }

        span{
            display: inline-block;
            margin-right: 10px;
            color: red;
        }
    }


    ul.category{
        list-style: none;
        padding-left: 0;

        li{
            color: rgb(96, 96, 96);
            font-weight: 500;
            line-height: 24px;
            margin-bottom: 10px;
        }
    }


    

`

const ViewBtn = styled.a`
    background: rgb(231, 60, 62);
    padding: 15px 40px;
    border-radius: 3px;
    cursor: pointer;
    display: inlline-block;
    color: rgb(255,255,255);

    

 `
export default LoanComponent
